define('services/aaausermanager',["require", "exports", "durandal/app", "models/account", "models/portal", "services/httpclient", "services/settings", "services/oneclickusermanager", "common/string", "services/trace"], function (require, exports, App, Account, Portal, Http, Configuration, OneClickUserManager, Strings, Trace) {
    "use strict";
    var AUTHORIZE_ENDPOINT = "/auth/core/connect/authorize";
    var END_SESSION_ENDPOINT = "/auth/core/connect/endsession";
    var TOKEN_ENDPOINT = "/auth/core/connect/token";
    var CHANGEPASSWORD_ENDPOINT = "/extern/security";
    var SECRET = "oneclick.secret";
    var SCOPE = "openid WK.UK.OneClick IdentityPersonalData";
    var CODEFLOW = "authorizationcode";
    var IMPLICITFLOW = "implicit";
    var openIntegrationUrl = "/open-integration";
    var messagesDocumentsUrl = "/messages-documents";
    var mtdfvUrl = "/mtdfv";
    var redirectCookieName = "redirectOneClickModule";
    var employeeMemberType = "stb_postmaster";
    var clientMemberType = "client_postmaster";
    var AAAUserManager = (function () {
        function AAAUserManager(clientId, leadingApplication) {
            this._flow = CODEFLOW;
            this._location = null;
            this._shell = Portal.Context.shell;
            this._taskManager = this._shell.taskManager;
            this._location = window.location;
            this._clientSecret = Strings.isNullOrEmpty(Configuration.Settings.environment.userManager.clientSecret)
                ? SECRET
                : jQuery.base64.decode(Configuration.Settings.environment.userManager.clientSecret);
            this._leadingApplication = leadingApplication || "oneclick";
            this._flow = Configuration.Settings.environment.userManager.flow || CODEFLOW;
            this._serverUrl = Configuration.Settings.environment.userManager.serverUrl + AUTHORIZE_ENDPOINT;
            this._changePasswordUrl = Configuration.Settings.environment.userManager.serverUrl + CHANGEPASSWORD_ENDPOINT;
            this._oneclickUserManager = new OneClickUserManager();
            this._redirectUrl = Configuration.Settings.getTokenExchangeEndpoint();
            this._postLogoutUrl = window.location.protocol + "//" + window.location.hostname + "/html";
        }
        AAAUserManager.prototype.showDialog = function () {
            var deeplinkModule = "";
            if (document.cookie.indexOf(redirectCookieName) >= 0) {
                var redirectCookieValue = this.getCookie(redirectCookieName);
                console.log("Cookie value : " + redirectCookieValue.toLowerCase());
                if (redirectCookieValue !== "" && redirectCookieValue.toLowerCase() == openIntegrationUrl.toLowerCase()) {
                    console.log("entered : " + openIntegrationUrl.toLowerCase());
                    deeplinkModule = openIntegrationUrl.toLowerCase();
                    // Removing cookie so that it won't be used next time
                    var expirationTime = new Date(new Date().getTime());
                    document.cookie = redirectCookieName + "=" + redirectCookieValue.toLowerCase() + ";expires=" + expirationTime.toUTCString() + ";path=/;";
                }
                else if (redirectCookieValue !== "" && redirectCookieValue.toLowerCase() == messagesDocumentsUrl.toLowerCase()) {
                    console.log("entered : " + messagesDocumentsUrl.toLowerCase());
                    deeplinkModule = messagesDocumentsUrl.toLowerCase();
                    // Removing cookie so that it won't be used next time
                    var expirationTime = new Date(new Date().getTime());
                    document.cookie = redirectCookieName + "=" + redirectCookieValue.toLowerCase() + ";expires=" + expirationTime.toUTCString() + ";path=/;";
                }
                else if (redirectCookieValue !== "" && redirectCookieValue.toLowerCase() == mtdfvUrl.toLowerCase()) {
                    console.log("entered : " + mtdfvUrl.toLowerCase());
                    deeplinkModule = mtdfvUrl.toLowerCase();
                    // Removing cookie so that it won't be used next time
                    var expirationTime = new Date(new Date().getTime());
                    document.cookie = redirectCookieName + "=" + redirectCookieValue.toLowerCase() + ";expires=" + expirationTime.toUTCString() + ";path=/;";
                }
            }
            var responseType = (this._flow === CODEFLOW) ? "code" : "id_token";
            var hash = window.location.hash;
            var search = window.location.search;
            if (hash === "")
                hash = "#home";
            var aaaConfigurationData = Configuration.Settings.environment.userManager.aaaConfiguration;
            var state = jQuery.base64.encode(window.location.protocol + "//" + window.location.hostname + "/html" + ";" + this._redirectUrl + ";" + aaaConfigurationData.isMFAEnabled + ";" + aaaConfigurationData.practiceGuid + ((deeplinkModule != "") ? ";" + deeplinkModule : "")); //jQuery.base64.encode(hash + search, true);
            var nonce = Math.random().toString(); //rand();
            var url = "";
            this._clientId = aaaConfigurationData.isMFAEnabled ? 'WK.UK.OneClick.MFA' : 'WK.UK.OneClick';
            var prompt = aaaConfigurationData.isSSOEnabled ? "prompt=login&" : "";
            var acrValues = aaaConfigurationData.isAAAEnabled ? "acr_values=" : "";
            acrValues += !aaaConfigurationData.isSSOEnabled ? "wkBranding:" + aaaConfigurationData.organizationalUnitId + " wkFilterByBrandingId:true" : "";
            acrValues += aaaConfigurationData.isSSOEnabled ? "idp:" + aaaConfigurationData.ssoIdentityProvider + " wkBranding:" + aaaConfigurationData.organizationalUnitId + " wkFilterByBrandingId:true" : "";
            if (window.location.search === '?logout=true' || (window.location.href === window.location.protocol + "//" + window.location.hostname + "/html/#logout")) {
                if (localStorage['idToken'] != undefined && localStorage['idToken'] != "null") {
                    url = Configuration.Settings.environment.userManager.serverUrl + END_SESSION_ENDPOINT
                        + "?id_token_hint=" + localStorage['idToken']
                        + "&post_logout_redirect_uri=" + encodeURI(this._postLogoutUrl);
                    localStorage.removeItem('idToken');
                    localStorage.removeItem('deepLink');
                }
                else {
                    url = window.location.protocol + "//" + window.location.hostname + "/html";
                }
            }
            else {
                url = this._serverUrl + "?" +
                    "client_id=" + encodeURI(this._clientId) + "&" +
                    "redirect_uri=" + encodeURI(this._redirectUrl) + "&" +
                    "nocompanysession" + "&" +
                    "response_type=" + encodeURI(responseType) + "&" +
                    "scope=" + encodeURI(SCOPE) + "&" +
                    "state=" + state + "&" +
                    "nonce=" + encodeURI(nonce) + "&" +
                    prompt +
                    acrValues;
            }
            console.log("AAA UserManager showDialog executed : " + url);
            window.location.assign(url);
        };
        AAAUserManager.prototype.getPrincipal = function () {
            var that = this;
            var channel = new Http.Channel();
            var currentSystemLanguage = i18n.lng();
            return channel.getData("/api/Account/Principal", Http.ServiceTarget.portalApi)
                .then(function (result) {
                var principal = Account.Principal.from(result, currentSystemLanguage);
                if (Strings.contains(Account.Principal.current.memberType, "_gateway")) {
                    that.signOut();
                    throw "Dieser Benutzer dient dem Datenaustausch mit externen Systemen, eine direkte Anmeldung ist mit ihm nicht möglich.";
                }
                return principal;
            })
                .fail(function (reason) {
                Trace.traceError("Fehler bei der Anmeldung: " + reason, null, "Anmeldung", true);
                return $.Deferred().reject(reason).promise();
            });
        };
        // #region get cookie by name
        AAAUserManager.prototype.getCookie = function (cname) {
            var name = cname + "=";
            var decodedCookie = decodeURIComponent(document.cookie);
            var ca = decodedCookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        };
        // #endregion
        AAAUserManager.prototype.signInFromSecret = function (symbol) {
            // delegate it
            return this._oneclickUserManager.signInFromSecret(symbol);
        };
        AAAUserManager.prototype.signInFromSessionId = function (symbol) {
            // delegate it
            return this._oneclickUserManager.signInFromSessionId(symbol);
        };
        AAAUserManager.prototype.signIn = function (login) {
            // delegate it - this is used for account switching for contacts linked to multiple clients
            return this._oneclickUserManager.signIn(login);
        };
        AAAUserManager.prototype.signInFromNid = function (symbol) {
            throw new Error('Method not implemented.');
        };
        AAAUserManager.prototype.signInFromRefreshToken = function () {
            throw new Error('Method not implemented.');
        };
        AAAUserManager.prototype.signInFromAccessToken = function (hash) {
            throw new Error('Method not implemented.');
        };
        AAAUserManager.prototype.signInFromAuthorizationCode = function (hash) {
            throw new Error('Method not implemented.');
        };
        AAAUserManager.prototype.redirectdeeplink = function (deeplink, sessionId, memberType) {
            var url = "";
            if (deeplink === messagesDocumentsUrl.toLowerCase()) {
                url = window.location.protocol + "//" + window.location.hostname + "/messages/OneClickAccount/Token?tokenId=" + sessionId + "&deepLink=true";
                window.location.assign(url);
            }
            else if (deeplink === openIntegrationUrl.toLowerCase()) {
                url = window.location.protocol + "//" + window.location.hostname + "/dw/#/default/businesses/business-list/list?tokenId=" + sessionId + "&fromfinsit=true";
                window.location.assign(url);
            }
            else if (deeplink === mtdfvUrl.toLowerCase()) {
                if (memberType === clientMemberType.toLocaleLowerCase()) {
                    url = window.location.protocol + "//" + window.location.hostname + "/compliance/#/?tokenId=" + sessionId;
                }
                else {
                    url = window.location.protocol + "//" + window.location.hostname + "/compliance/#/default/clients/select-client/list?tokenId=" + sessionId;
                }
                window.location.assign(url);
            }
        };
        AAAUserManager.prototype.signInFromIdToken = function (hash) {
            var hashValues = this.convertHash(hash);
            Account.Session.clear();
            localStorage['idToken'] = hashValues.id_token;
            var principal;
            var deeplink = hashValues.deepLink;
            var sessionId = hashValues.session;
            var memberType = hashValues.memberType;
            if (deeplink !== "null" && deeplink !== "" && deeplink !== undefined &&
                sessionId !== "null" && sessionId !== "" && sessionId !== undefined &&
                memberType !== "null" && memberType !== "" && memberType !== undefined &&
                (memberType.toLowerCase() === employeeMemberType.toLowerCase() || memberType.toLowerCase() === clientMemberType.toLowerCase()) &&
                (deeplink.toLowerCase() === messagesDocumentsUrl.toLowerCase() || deeplink.toLowerCase() === mtdfvUrl.toLowerCase() || deeplink.toLowerCase() === openIntegrationUrl.toLowerCase())) {
                if (memberType.toLowerCase() === clientMemberType.toLowerCase()) {
                    var aaaConfigurationData = Configuration.Settings.environment.userManager.aaaConfiguration;
                    var url = this.getSwitchUserAccountUrl();
                    var objDeepLink = {
                        deepLink: true,
                        organizationalUnitId: aaaConfigurationData.organizationalUnitId,
                        switchAccountUrl: url
                    };
                    localStorage.setItem('deepLink', JSON.stringify(objDeepLink));
                }
                this.redirectdeeplink(deeplink.toLowerCase(), sessionId, memberType.toLowerCase());
                return Q.resolve(null); // No principal to return, so resolve with null
            }
            else {
                Account.Session.setAuthentication(hashValues.access_token, hashValues.expires);
                // Convert jQueryPromise to Q.Promise
                return Q(this.getPrincipal())
                    .then(function (resolvedPrincipal) {
                    principal = resolvedPrincipal;
                    Account.Principal.current = principal;
                    Account.Session.loginName = principal.loginName; // Use the loginName from the principal object
                    App.trigger("authentication", true);
                    return principal; // Return the principal as the resolved value
                })
                    .catch(function (reason) {
                    console.error("Failed to get principal:", reason);
                    // Handle the error, possibly by rejecting the promise
                    return Q.reject(reason);
                });
            }
        };
        AAAUserManager.prototype.signInFromSsoHash = function (hash) {
            throw new Error("Method not implemented.");
        };
        AAAUserManager.prototype.signOutSwitchUser = function () {
            this.endSession();
        };
        AAAUserManager.prototype.switchUserAccount = function () {
            var switcherurl = "";
            Account.Session.clear();
            var responseType = (this._flow === CODEFLOW) ? "code" : "id_token";
            var aaaConfigurationData = Configuration.Settings.environment.userManager.aaaConfiguration;
            this._clientId = aaaConfigurationData.isMFAEnabled ? 'WK.UK.OneClick.MFA' : 'WK.UK.OneClick';
            var state = jQuery.base64.encode(window.location.protocol + "//" + window.location.hostname + "/html" + ";" + this._redirectUrl + ";" + aaaConfigurationData.isMFAEnabled + ";" + aaaConfigurationData.practiceGuid); //jQuery.base64.encode(hash + search, true);
            var nonce = Math.random().toString();
            var prompt = aaaConfigurationData.isSSOEnabled ? "prompt=login&" : "";
            var acrValues = aaaConfigurationData.isAAAEnabled ? "acr_values=" : "";
            acrValues += !aaaConfigurationData.isSSOEnabled ? "wkBranding:" + aaaConfigurationData.organizationalUnitId + " wkFilterByBrandingId:true" : "";
            acrValues += aaaConfigurationData.isSSOEnabled ? "idp:" + aaaConfigurationData.ssoIdentityProvider + " wkBranding:" + aaaConfigurationData.organizationalUnitId + " wkFilterByBrandingId:true wkContextManager:noCompanySession" : "";
            switcherurl = this._serverUrl + "?" +
                "client_id=" + encodeURI(this._clientId) + "&" +
                "redirect_uri=" + encodeURI(this._redirectUrl) + "&" +
                "nocompanysession" + "&" +
                "response_type=" + encodeURI(responseType) + "&" +
                "scope=" + encodeURI(SCOPE) + "&" +
                "state=" + state + "&" +
                "nonce=" + encodeURI(nonce) + "&" +
                prompt +
                acrValues;
            console.log("AAA UserManager switchUserAccount executed : " + switcherurl);
            window.location.assign(switcherurl);
        };
        AAAUserManager.prototype.getSwitchUserAccountUrl = function () {
            var switcherurl = "";
            var responseType = (this._flow === CODEFLOW) ? "code" : "id_token";
            var aaaConfigurationData = Configuration.Settings.environment.userManager.aaaConfiguration;
            this._clientId = aaaConfigurationData.isMFAEnabled ? 'WK.UK.OneClick.MFA' : 'WK.UK.OneClick';
            var state = jQuery.base64.encode(window.location.protocol + "//" + window.location.hostname + "/html" + ";" + this._redirectUrl + ";" + aaaConfigurationData.isMFAEnabled + ";" + aaaConfigurationData.practiceGuid + ";" + messagesDocumentsUrl); //jQuery.base64.encode(hash + search, true);
            var nonce = Math.random().toString();
            var prompt = aaaConfigurationData.isSSOEnabled ? "prompt=login&" : "";
            var acrValues = aaaConfigurationData.isAAAEnabled ? "acr_values=" : "";
            acrValues += !aaaConfigurationData.isSSOEnabled ? "wkBranding:" + aaaConfigurationData.organizationalUnitId + " wkFilterByBrandingId:true" : "";
            acrValues += aaaConfigurationData.isSSOEnabled ? "idp:" + aaaConfigurationData.ssoIdentityProvider + " wkBranding:" + aaaConfigurationData.organizationalUnitId + " wkFilterByBrandingId:true wkContextManager:noCompanySession" : "";
            switcherurl = this._serverUrl + "?" +
                "client_id=" + encodeURI(this._clientId) + "&" +
                "redirect_uri=" + encodeURI(this._redirectUrl) + "&" +
                "nocompanysession" + "&" +
                "response_type=" + encodeURI(responseType) + "&" +
                "scope=" + encodeURI(SCOPE) + "&" +
                "state=" + state + "&" +
                "nonce=" + encodeURI(nonce) + "&" +
                prompt +
                acrValues;
            console.log("AAA UserManager getSwitchUserAccountUrl executed : " + switcherurl);
            return switcherurl;
        };
        AAAUserManager.prototype.endSession = function () {
            // send to server
            var channel = new Http.Channel();
            channel.postDataAsync("/api/account/logout", Http.ServiceTarget.portalApi, null);
            // in jedem Fall
            Account.Session.clear();
        };
        AAAUserManager.prototype.signOut = function () {
            this.endSession();
            var postLogoutUrl = this._postLogoutUrl + "/?logout=true";
            var aaaConfigurationData = Configuration.Settings.environment.userManager.aaaConfiguration;
            var clientId = aaaConfigurationData.isMFAEnabled ? 'WK.UK.OneClick.MFA' : 'WK.UK.OneClick';
            var url = Configuration.Settings.environment.getCustomValue("LogoutUrl") + "?clientid=" + clientId + "&redirecturl=" + encodeURI(postLogoutUrl);
            localStorage.removeItem('deepLink');
            window.location.assign(url);
        };
        AAAUserManager.prototype.getSettings = function (key) {
            var that = this;
            var channel = new Http.Channel();
            var settingsUrl = "/api/Account/me/settings/" + key;
            return channel.getDataAsync(settingsUrl, Http.ServiceTarget.portalApi);
        };
        AAAUserManager.prototype.saveSettings = function (key, settings) {
            var that = this;
            var channel = new Http.Channel();
            var settingsUrl = "/api/Account/me/settings/" + key;
            return channel.postDataAsync(settingsUrl, Http.ServiceTarget.portalApi, settings);
        };
        AAAUserManager.prototype.changePassword = function (memberId, hash, password) {
            // delegate it
            return this._oneclickUserManager.changePassword(memberId, hash, password);
        };
        AAAUserManager.prototype.setPasswordFor = function (userId, memberId, password) {
            // delegate it
            return this._oneclickUserManager.setPasswordFor(userId, memberId, password);
        };
        AAAUserManager.prototype.resetPassword = function (login) {
            // delegate it
            return this._oneclickUserManager.resetPassword(login);
        };
        AAAUserManager.prototype.getChangePasswordUrl = function () {
            return this._changePasswordUrl;
        };
        AAAUserManager.prototype.convertHash = function (hash) {
            var response = hash.substr(1);
            return response.split("&")
                .reduce(function (result, item) {
                var parts = item.split("=");
                result[parts[0]] = parts[1];
                return result;
            }, {});
        };
        return AAAUserManager;
    }());
    return AAAUserManager;
});

